const BIGQUERY_MAX_DECIMALS = 6;

const toFixedNumber = (value, fractionDigits = BIGQUERY_MAX_DECIMALS) => {
  if (Number.isNaN(value) || !value || Number.isInteger(value) || typeof value === 'string') {
    return value;
  }

  return parseFloat(value.toFixed(fractionDigits));
};

const truncateDecimals = (value, numDecimalPlaces = 2) => {
  if (Number.isNaN(value) || !value || typeof value === 'string') {
    return value;
  }

  if (Number.isNaN(numDecimalPlaces) || typeof numDecimalPlaces === 'string') return value;

  return Math.trunc(value * 10 ** (numDecimalPlaces)) / 10 ** (numDecimalPlaces);
};

module.exports = { toFixedNumber, truncateDecimals, BIGQUERY_MAX_DECIMALS };
